// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Link as MuiLink } from "@mui/material";

import href from "../util/href";

/**
 * Our Link adds the `rel="noopener"` attribute.
 * External links should always use `noopener`; internal links can override `rel`
 * if required.
 *
 * There are no other differences from MaterialUI.
 *
 * @see https://web.dev/external-anchors-use-rel-noopener/
 * @see https://material-ui.com/api/Link/
 */

const Link = (props) => {
  return (
    <MuiLink
      rel="noopener"
      {...props}
      href={href.sanitize(props.href, window.location.toString())}
    />
  );
};

export default Link;
